<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <table-custom
      :board="board"
      :is-print="isPrint"
      title="관리부서"
      :tableData="[
        { id: 'no', title: '연번', type: 'no', width: 120 },
        { id: 'input1', title: '성명', type: 'text', placeholder: '내용' },
        { id: 'input2', title: '직위', type: 'text', placeholder: '내용' },
        {
          id: 'input3',
          title: '담당업무',
          type: 'select',
          selectData: ['시설 안전조치', '유지보수 업무', '기타 안전관리', '안전관리 총괄'],
          placeholder: '선택',
        },
        { id: 'input4', title: '연락처', type: 'text', placeholder: '내용' },
        { id: 'input5', title: '인원수', type: 'number' },
      ]"
      v-model="form.companyList1"
    >
      <template #customTr>
        <tr style="background: #f9f9f9 !important">
          <td :colspan="isPrint ? 4 : 5"></td>
          <td class="text-center">소계</td>
          <td style="padding: 10px 15px">
            <comma-input readonly placeholder="자동입력" v-model="form.workerNum1" class="w-full flex-1" />
          </td>
        </tr>
      </template>
    </table-custom>

    <table-custom
      :board="board"
      :is-print="isPrint"
      title="수탁업체"
      :tableData="[
        { id: 'no', title: '연번', type: 'no', width: 120 },
        { id: 'input1', title: '성명', type: 'text', placeholder: '내용' },
        { id: 'input2', title: '업체명', type: 'text', placeholder: '내용' },
        {
          id: 'input3',
          title: '담당업무',
          type: 'select',
          selectData: ['시설 안전조치', '유지보수 업무', '기타 안전관리', '안전관리 총괄'],
          placeholder: '선택',
        },
        { id: 'input4', title: '연락처', type: 'text', placeholder: '내용' },
        { id: 'input5', title: '인원수', type: 'number' },
      ]"
      v-model="form.companyList2"
    >
      <template #customTr>
        <tr style="background: #f9f9f9 !important">
          <td :colspan="isPrint ? 4 : 5"></td>
          <td class="text-center">소계</td>
          <td style="padding: 10px 15px">
            <comma-input readonly placeholder="자동입력" v-model="form.workerNum2" class="w-full flex-1" />
          </td>
        </tr>
      </template>
    </table-custom>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";

export default {
  components: {
    TableCustom,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
    "form.companyList1": {
      immediate: true,
      deep: true,
      handler(value) {
        for (const key of value) {
          if (!key.input3 || key.input3 === "") {
            key.input3 = "시설 안전조치";
          }
        }
        // 인원수 소계
        if (!!value && 0 < value.length) {
          this.form.workerNum1 = value.reduce((prev, _w) => {
            const n = Number(_w.input5 || 0);
            return n + prev;
          }, 0);
        } else this.form.workerNum1 = null;
      },
    },
    "form.companyList2": {
      immediate: true,
      deep: true,
      handler(value) {
        for (const key of value) {
          if (!key.input3 || key.input3 === "") {
            key.input3 = "시설 안전조치";
          }
        }
        // 인원수 소계
        if (!!value && 0 < value.length) {
          this.form.workerNum2 = value.reduce((prev, _w) => {
            const n = Number(_w.input5 || 0);
            return n + prev;
          }, 0);
        } else this.form.workerNum2 = null;
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],

        companyList1: [],
        companyList2: [],
        workerNum1: null,
        workerNum2: null,
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss"></style>
